import React from 'react';
const IconCommentWaiting = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22L21.99 4C21.99 2.9 21.1 2 20 2ZM17 11H15V9H17V11ZM11 11H13V9H11V11ZM9 11H7V9H9V11Z" fill="#666666"/>
</svg>
);
};
export default IconCommentWaiting;